import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import {InputMaskModule} from 'primeng/inputmask';
import { BaseControl, TypeChecker } from '../../../shared';

@Component({
  selector: 'form-input-mask-control',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule,
    InputMaskModule
  ],
  template: `
    <div [formGroup]="formGroup" *ngIf="typeChecker.isInputMask(control)" class="w-full">
        <p-inputMask [formControlName]="control.name" styleClass="w-full"
          [mask]="control.mask" [placeholder]="control.placeholder"></p-inputMask>
    </div> 
  `,
  styles: `
    :host {
      display: contents;
    }
  `
})
export class InputMaskControlComponent {
  @Input() control !: BaseControl<any>;
  @Input() formGroup !: FormGroup;

  typeChecker = TypeChecker;
}
